<template>
    <section 
        :class="[
            props.theme == 'dark' ? 'tw-bg-[#1E283A] tw-text-white' : 'tw-bg-[#e9eef6] tw-text-black',
            isCollapsed ? 'tw-rounded-l-[15px] tw-mr-0 tw-w-auto tw-px-2 tw-py-3' : 'tw-rounded-[15px] tw-w-max tw-px-3 tw-py-2',
        ]"
        class="
            tw-text-black
            tw-text-[0.8em]
            tw-font-extrabold
            tw-capitalize
            tw-shadow-2xl
            tw-fixed
            tw-z-[1]
            tw-right-0
            tw-top-[18%]
            tw-m-[2vh]
            tw-max-w-[95vw]
            tw-transition-all
            tw-duration-300
            tw-ease-in-out
            tw-cursor-pointer
            hover:tw-shadow-lg
            tw-select-none
        ">
        <div v-if="isCollapsed" @click="isCollapsed = false" class="tw-flex tw-flex-col tw-items-center tw-gap-2">
            <div class="tw-flex tw-flex-col tw-items-center tw-gap-1">
                <img
                    src="/images/icons/estacao/sol.png"
                    alt="temperatura"
                    class="tw-w-5 tw-h-5"
                />
                <span class="tw-text-[0.75em] tw-font-bold">
                    {{ estacaoData ? estacaoData.temperatura : "--" }}°
                </span>
            </div>

            <div class="tw-h-px tw-w-6 tw-bg-slate-400 tw-opacity-50"></div>

            <div class="tw-flex tw-flex-col tw-items-center tw-gap-1">
                <img
                    src="/images/icons/estacao/umidade.png"
                    alt="umidade"
                    class="tw-w-5 tw-h-5"
                />
                <span class="tw-text-[0.75em] tw-font-bold">
                    {{ estacaoData ? estacaoData.umidade : "--" }}%
                </span>
            </div>

            <div class="tw-h-px tw-w-6 tw-bg-slate-400 tw-opacity-50"></div>

            <div class="tw-flex tw-flex-col tw-items-center tw-gap-1">
                <img
                    src="/images/icons/estacao/nuvem.png"
                    alt="chuva"
                    class="tw-w-5 tw-h-5"
                />
                <span class="tw-text-[0.75em] tw-font-bold">
                    {{ estacaoData && estacaoData.chuva > 0 ? "S" : "N" }}
                </span>
            </div>
        </div>
        <div v-else @click="isCollapsed = true" class="tw-flex tw-flex-col tw-gap-3">
            <div class="tw-flex tw-items-center tw-gap-3 tw-whitespace-nowrap">
                <div class="tw-flex tw-items-center tw-gap-1">
                    <img
                        src="/images/icons/estacao/sol.png"
                        alt="temperatura"
                        class="tw-w-4 tw-h-4"
                    />
                    <span>
                        {{ estacaoData ? estacaoData.temperatura : "--" }}°C
                    </span>
                </div>
                <div class="tw-text-slate-400">|</div>
                <div class="tw-flex tw-items-center tw-gap-1">
                    <img
                        src="/images/icons/estacao/umidade.png"
                        alt="umidade"
                        class="tw-w-4 tw-h-4"
                    />
                    <span>
                        {{ estacaoData ? estacaoData.umidade : "--" }}%
                    </span>
                </div>
                <div class="tw-text-slate-400">|</div>
                <div class="tw-flex tw-items-center tw-gap-1">
                    <img
                        src="/images/icons/estacao/nuvem.png"
                        alt="chuva"
                        class="tw-w-4 tw-h-4"
                    />
                    <span>
                        {{ estacaoData && estacaoData.chuva > 0 ? "Chovendo" : "Sem chuva" }}
                    </span>
                </div>
            </div>
            <div class="tw-mt-1 tw-text-center tw-text-[0.7em] tw-font-semibold">
                Estação {{ estacaoData ? estacaoData.estacao : "--" }} -
                {{ estacaoData ? dataFormatada(estacaoData.data) : "--" }}
            </div>
        </div>
    </section>
</template>
<script>
import { ref, onMounted } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";

export default {
    name: "EstacaoComponent",
    props: {
        theme: {
            type: String,
        },
    },
    setup(props) {
        const store = useStore();
        const route = useRoute();
        const estacaoData = ref({});
        const isCollapsed = ref(window.innerWidth < 500);
        const dataFormatada = (data) => {
            const date = new Date(data);
            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const year = date.getFullYear();
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');
            const seconds = String(date.getSeconds()).padStart(2, '0');
            return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
        };

        onMounted(async () => {
            const unidadeId = route.params.unidade;
            estacaoData.value = (await store.dispatch("unidade/getEstacaoByUnidade", unidadeId)).estacao;
        });

        return {
            dataFormatada,
            estacaoData,
            isCollapsed,
            props
        };
    },
};
</script>
